var map = {
	"./en/GameConsole-banner1.jpg": "aae9",
	"./en/GameConsole-banner2.jpg": "a975",
	"./en/GameConsole-game.png": "37d2",
	"./en/GameConsole-right.png": "6075",
	"./en/GamePopular-title.png": "9001",
	"./en/GamePrizePool-title.png": "ac52",
	"./en/activity_bg.jpg": "00f5",
	"./en/black_board_a001_title.png": "2c41",
	"./en/black_casion_a001_title.png": "d204",
	"./en/black_fishing_a001_title.png": "79ac",
	"./en/btn-login.png": "0191",
	"./en/btn-register.png": "75ab",
	"./en/icon-active.png": "b517",
	"./en/icon-hot.png": "02a7",
	"./en/icon-tuijian.png": "305a",
	"./en/text/deposit1.jpg": "69a8",
	"./en/text/deposit2.jpg": "15a3",
	"./en/text/deposit3.jpg": "b8bf",
	"./en/text/deposit4.jpg": "ef28",
	"./en/text/deposit5.jpg": "a4d6",
	"./en/text/help8.png": "1b06",
	"./en/text/withdraw1.jpg": "5526",
	"./en/text/withdraw2.jpg": "6cf5",
	"./en/text/withdraw3.jpg": "839c",
	"./en/text/withdraw4-1.jpg": "87e5",
	"./en/text/withdraw4-2.jpg": "c3a3",
	"./en/text/withdraw4.jpg": "d702",
	"./en/wrap-login.png": "fcc6",
	"./zh_CN/GameConsole-banner1.jpg": "704f",
	"./zh_CN/GameConsole-banner2.jpg": "9ab7",
	"./zh_CN/GameConsole-game.png": "26cb",
	"./zh_CN/GameConsole-right.png": "5d262",
	"./zh_CN/GamePopular-title.png": "a25e",
	"./zh_CN/GamePrizePool-title.png": "2713",
	"./zh_CN/activity_bg.jpg": "9f3e",
	"./zh_CN/black_board_a001_title.png": "fb61",
	"./zh_CN/black_casion_a001_title.png": "07d4",
	"./zh_CN/black_fishing_a001_title.png": "23bb",
	"./zh_CN/btn-login.png": "8d02",
	"./zh_CN/btn-register.png": "5f39",
	"./zh_CN/icon-active.png": "614f",
	"./zh_CN/icon-hot.png": "ced5",
	"./zh_CN/icon-tuijian.png": "1654",
	"./zh_CN/text/deposit1.jpg": "7d9d",
	"./zh_CN/text/deposit2.jpg": "52fe",
	"./zh_CN/text/deposit3.jpg": "6b46",
	"./zh_CN/text/deposit4.jpg": "03d0",
	"./zh_CN/text/deposit5.jpg": "d6f3",
	"./zh_CN/text/help8.png": "36bd",
	"./zh_CN/text/withdraw1.jpg": "ab41",
	"./zh_CN/text/withdraw2.jpg": "7a36",
	"./zh_CN/text/withdraw3.jpg": "bab1",
	"./zh_CN/text/withdraw4-1.jpg": "c6eb",
	"./zh_CN/text/withdraw4-2.jpg": "798c",
	"./zh_CN/wrap-login.png": "ed60a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3a0";